import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BeautybookService } from '@features/beautybook/services/beautybook.service';
import { CartService } from '@features/cart/services/cart.service';
import { faComment, faHeart, faShare } from '@fortawesome/free-solid-svg-icons';
import { FcSharingComponent } from '@shared/components/fc-sharing/fc-sharing.component';
import { DataListParameter } from '@shared/interfaces/data-list-parameter.interface';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { LayoutService } from 'src/app/layout/services/layout.service';

@Component({
  selector: 'fc-beautybook-detail',
  templateUrl: './beautybook-detail.component.html',
  styleUrls: ['./beautybook-detail.component.css'],
})
export class BeautybookDetailComponent implements OnInit {
  faHeart = faHeart;
  faComment = faComment;
  faShare = faShare;

  beautybookPostId;
  beautybookPost: any;
  comments: any;

  loading = true;

  beautybookCommentForm!: FormGroup;

  details = [
    {
      username: 'Christine Hakim',
      date: '22-3-2022',
      caption:
        "Great idea to use the product on your face. I'm gonna try it too. Thanks for sharing! I think I'll try the pink one.",
    },
  ];
  constructor(
    private beautybookService: BeautybookService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private cartService: CartService,
    private layoutService: LayoutService,
    private dialogService: DialogService
  ) {
    this.beautybookPostId = +Number(this.route.snapshot.paramMap.get('id'));
    this.beautybookCommentForm = new FormGroup({
      comment: new FormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    this.beautybookService
      .getBeautybookPost(this.beautybookPostId)
      .subscribe((res) => {
        this.beautybookPost = res;
        this.loading = false;
      });
    this.getComments();
  }
  getComments() {
    let param: DataListParameter = {
      item_per_page: 1000,
      current_page: 1,
      sorts: [{ field: 'created_at', direction: 'desc' }],
    };
    this.beautybookService
      .getComments(this.beautybookPostId, param)
      .subscribe((res) => {
        this.comments = res;
      });
  }
  like() {
    if (this.beautybookPost.already_like) {
      this.beautybookService
        .unlike(this.beautybookPostId, 'posts')
        .subscribe((res) => {
          this.beautybookPost.already_like = false;
          this.beautybookPost.total_likes -= 1;
        });
    } else {
      this.beautybookService
        .like(this.beautybookPostId, 'posts')
        .subscribe((res) => {
          this.beautybookPost.already_like = true;
          this.beautybookPost.total_likes += 1;
        });
    }
  }
  onSubmit() {
    this.beautybookService
      .postComment(
        this.beautybookPostId,
        this.beautybookCommentForm.value.comment
      )
      .subscribe((res) => {
        this.getComments();
        this.beautybookPost.total_comments += 1;
        this.beautybookCommentForm.reset();
      });
  }
  addToCart() {
    console.log(this.beautybookPost.post_products[0].product_id);
    console.log(this.beautybookPost.post_products[0].product_variant_id);
    this.cartService
      .addCartItem(
        this.beautybookPost.post_products[0].product_id,
        this.beautybookPost.post_products[0].product_variant_id,
        1
      )
      .subscribe((cartItem: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Product added to cart',
        });
      });
  }
  onShare() {
    let style = {};
    if (this.layoutService.isMobile$.value) {
      style = {
        'max-height': '100%',
        width: '100vh',
        height: '100vh',
        overflow: 'hidden',
      };
    } else {
      style = {
        'border-radius': '1rem',
        overflow: 'hidden',
      };
    }
    const ref = this.dialogService.open(FcSharingComponent, {
      dismissableMask: true,
      closable: true,
      showHeader: false,
      width: '500px',
      contentStyle: {
        padding: '0',
      },
      style: style,
    });
    ref.onClose.subscribe();
  }
}
